<template>
  <v-row>
    <v-col
      v-for="(item, i) in items"
      :key="i"
      cols="12"
    >
      <v-btn
        block
        :loading="saving"
        @click="click(item.id)"
      >
        <v-icon v-if="item.icon">
          {{ item.icon }}
        </v-icon>
        {{ item.label }}
      </v-btn>
    </v-col>
    <SelectDialog
      ref="select"
      :title="currentItem.title"
      :text-label="currentItem.textLabel"
      :rules="currentItem.rules"
      @save="handleSelect"
    />
  </v-row>
</template>

<script>
import SelectDialog from '@/components/common/SelectDialog';
import { mapGetters } from 'vuex';
export default {
  name: 'UserCardDetails',
  components: { SelectDialog },
  data: () => ({
    current: null,
    saving: false
  }),
  computed: {
    currentItem() {
      return this.items.find((x) => x.id === this.current) || {};
    },
    items() {
      return [
        {
          label: 'Copy Project',
          title: 'Copy Project',
          icon: 'content_copy',
          id: 'copy_project',
          textLabel: 'Project Id'
        },
        {
          label: 'Change User Name',
          title: 'Change User Name',
          icon: 'alternate_email',
          id: 'change_username',
          textLabel: 'New Username',
          rules: [this.$rules.email]
        },
        { label: 'Set Print Only', icon: 'print', id: 'set_print_only' },
        {
          label: 'Reset Default Password',
          icon: 'key',
          id: 'reset_default_password'
        }
      ];
    },
    ...mapGetters({ user: 'users/user' })
  },
  methods: {
    click(id) {
      this.current = id;
      let action = '';
      const req = {};
      let snack = '';
      switch (id) {
        case 'import_all':
        case 'copy_project':
        case 'change_username':
          this.$refs.select.show();
          return;
        case 'set_print_only':
          action = 'users/setPrintOnly';
          snack = 'User Updated';
          break;
        case 'reset_default_password':
          action = 'users/resetDefaultPassword';
          snack = 'Password Updated';
          break;
      }

      if (action) {
        this.save(action, req, snack);
      }
    },
    handleSelect(value) {
      switch (this.current) {
        case 'copy_project':
          this.save('users/copyProject', { projectId: value });
          break;
        case 'change_username':
          this.save('users/changeUsername', { newUsername: value });
          break;
      }
    },
    save(action, req, snack) {
      this.saving = true;
      this.$store
        .dispatch(action, Object.assign({ userId: this.user.id }, req))
        .then((data) => {
          if (!snack) {
            snack = data;
          }
          this.$root.$snackbarSuccess(snack);
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
